import { useEffect, useState } from "react";
import { BorderButton } from "../buttons/BorderButton";
import Modal from "./Modal";

interface Props {
  visible: boolean;
  handleOk: () => void;
  handleCancel: () => void;
}

export function ConfirmNavigationModal(props: Props) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (props.visible) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, [props.visible]);

  return (
    <Modal
      visible={visible}
      handleCancel={props.handleCancel}
      footer={
        <>
          <BorderButton type="submit" onClick={props.handleOk}>
            Confirm
          </BorderButton>
          <BorderButton onClick={props.handleCancel}>Cancel</BorderButton>
        </>
      }
      title="You have unsaved changes"
    >
      <p>Your changes have not been saved yet.</p>
    </Modal>
  );
}
